import React from 'react';
import { Container, styled } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

const FiltersContainer: React.FC<Props> = ({ children }) => {
  return (
    <Wrapper>
      <InnerWrapper disableGutters>{children}</InnerWrapper>
    </Wrapper>
  );
};

export default FiltersContainer;

const Wrapper = styled(Container)`
  width: 100%;
  margin-bottom: -30px;
  padding: 0;
`;

const InnerWrapper = styled(Container)`
  background: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  padding-top: 1px;
`;
